import type { JSX } from 'react';
import { SettingsEmpty } from '@taki/ui';
import type { AppDeclaree } from './app-declaree.js';
import { ReglageDemo, demoOfferte } from './ReglageDemo.js';
import { useAppRuntime } from './runtime.js';

/**
 * LES REGLAGES D'UNE APP CANVAS, montes par le hub Parametres du shell. Sans
 * porte, ni vue d'arrivee ni listes : son affichage se regle dans l'app. Reste
 * le jeu de demonstration, s'il y en a un.
 */
export function ReglagesAppCanvas({ app }: { app: AppDeclaree }): JSX.Element {
  const { emulateurs } = useAppRuntime();
  return demoOfferte(app, emulateurs) ? <ReglageDemo app={app} /> : <SettingsEmpty>Aucun réglage.</SettingsEmpty>;
}

export default ReglagesAppCanvas;
